import { FAQ } from "config/FAQ/index"
import { useMemo } from 'react'
import { GetDataFAQ } from 'state/FAQ'
import { ContainerContent } from 'views/FAQ/styled'
import DescriptionCollaspe from "./component/DescriptionCollapse"
import DescriptionImage from "./component/DescriptionImage"

const Content = () => {
    // ================== VAR ==================
    // ================== STATE ==================
    const { activeTab } = GetDataFAQ()
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    // ================== EFFECT ==================
    const dataFAQ = useMemo(() => {
        return FAQ.find((dt) => dt?.type === activeTab)
    },[activeTab])
    // ================== RENDER ==================
    // ================== MAIN ==================
    return (
        <ContainerContent>
            { dataFAQ?.isCollapse ?
                <DescriptionCollaspe detail={dataFAQ?.faq}/>
            :
                <DescriptionImage detail={dataFAQ?.faq} />
            }
           
        </ContainerContent>
    )
}
export default Content
